import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { api } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";
import { useLang } from "../../context/LangContext";
import ChatDialog from "../../components/ChatDialog";
import SubPageShell from "../../components/SubPageShell";

export default function Messages() {
  const { user } = useAuth();
  const { t } = useLang();
  const navigate = useNavigate();
  const [convs, setConvs] = useState(null);
  const [chatConv, setChatConv] = useState(null);

  useEffect(() => {
    if (user === undefined) return;
    if (!user) { navigate("/login?next=/account/messages"); return; }
    api("/conversations", { auth: true }).then(setConvs).catch(() => setConvs([]));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  if (!user) return null;

  return (
    <SubPageShell title={t("tab_messages")} tid="messages-page">
      {convs === null ? (
        <p data-testid="messages-loading" className="py-10 text-center text-sm text-slate-500">...</p>
      ) : convs.length === 0 ? (
        <div data-testid="messages-empty" className="mt-6 rounded-2xl border border-dashed border-slate-300 py-12 text-center">
          <p className="font-heading font-semibold text-slate-800">{t("no_convs")}</p>
          <p className="mt-1 text-sm text-slate-500">{t("no_convs_sub")}</p>
        </div>
      ) : (
        <div className="space-y-3">
          {convs.map((c) => (
            <button
              key={c.id}
              data-testid={`conversation-row-${c.id}`}
              onClick={() => setChatConv(c)}
              className="flex w-full items-center gap-3.5 rounded-2xl bg-white p-4 text-left shadow-sm ring-1 ring-slate-100 transition hover:ring-teal-300"
            >
              <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-teal-700/10 text-teal-700">
                <MessageCircle className="h-5 w-5" />
              </div>
              <div className="min-w-0 flex-1">
                <p className="truncate text-sm font-semibold text-slate-900">{c.partner_name}</p>
                <p className="truncate text-xs text-slate-400">{c.last_message}</p>
              </div>
              {c.unread > 0 && (
                <span className="shrink-0 rounded-full bg-teal-700 px-2 py-0.5 text-xs font-bold text-white">{c.unread}</span>
              )}
              <span className="shrink-0 text-xs text-slate-300">{c.updated_at ? new Date(c.updated_at).toLocaleDateString() : ""}</span>
            </button>
          ))}
        </div>
      )}
      {chatConv && (
        <ChatDialog open={!!chatConv} onOpenChange={(v) => !v && setChatConv(null)} conversation={chatConv} />
      )}
    </SubPageShell>
  );
}
